import { PropsCatalogCategoryBlock } from './TypeProps';
import { MyLink } from '@ui-kit/MyLink';
import Image from 'next/image';

import styles from './CatalogCategoryBlock.module.scss';

export const CatalogCategoryBlock = ({ href, image, title }: PropsCatalogCategoryBlock): JSX.Element => {
  return (
    <MyLink color={'black'} className={styles.Item} href={href}>
      <div className={styles.ItemContent}>
        <div className={styles.Image}>
          <Image src={image} alt={image} width={120} height={120} layout="responsive" />
        </div>
        {title}
      </div>
    </MyLink>
  );
};
